import store from '@/store'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 异常捕捉
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [{
    path: '/',
    name: 'main',
    component: () => import('../views/Main.vue'),
    children: [{
        path: '/home',
        name: 'home',
        component: () => import('../views/Home.vue'),
        meta: {
          title: '票小助'
        }
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('../views/User.vue'),
        meta: {
          title: '票小助'
        }
      },
      {
        path: '/mall',
        name: 'mall',
        component: () => import('../views/Mall.vue'),
        meta: {
          title: '票小助'
        }
      },
      {
        path: '/Distribution',
        name: 'Distribution',
        component: () => import('../views/other/Distribution.vue'),
        meta: {
          title: '票小助'
        }
      },
      {
        path: '/Detailed',
        name: 'Detailed',
        component: () => import('../views/other/Detailed.vue'),
        meta: {
          title: '票小助'
        }
      },
      {
        path: '/SettlementCenter',
        name: 'SettlementCenter',
        component: () => import('../views/other/SettlementCenter.vue'),
        meta: {
          title: '票小助'
        }
      },
      {
        path: '/SettlementRecords',
        name: 'SettlementRecords',
        component: () => import('../views/other/SettlementRecords.vue'),
        meta: {
          title: '票小助'
        }
      },
      {
        path: '/ToBeAllocated',
        name: 'ToBeAllocated',
        component: () => import('../views/other/ToBeAllocated.vue'),
        meta: {
          title: '票小助'
        }
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
        meta: {
          title: '票小助'
        }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由导航
router.beforeEach((to, from, next) => {
  // ✅ 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '票小助系统';
  }
  // 获取是否存在token
  store.commit('getToken')
  const token = store.state.token;
  if (!token && to.name !== 'login') {
    next('login');
  } else if (token && to.name === 'login') {
    next('home');
  } else {
    next();
  }
})

export default router